import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      "fill-rule": "evenodd",
      d: "M20.204 4.01A2 2 0 0 1 22 6v12a2 2 0 0 1-1.796 1.99L20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16zM4 5.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h2v-13zm3.5 13H20a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5H7.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }